import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import NettingUpdaterForm from './NettingUpdaterForm'

const NettingUpdaterPage = () => {
  const [css, theme] = useStyletron()
  const { t } = useTranslation('organizationManagement')

  const blockStyle = css({
    padding: '1rem',
    marginBottom: '2rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(20,96,170,.15)',
    maxWidth: '480px',
    color: theme.colors.contentSecondary,
  })

  const headingStyle = css({
    margin: '0.5rem 5px 5px 5px',
    color: theme.colors.primary,
  })

  return (
    <div className={css({ padding: '1rem', color: 'white' })}>
      <div className={blockStyle}>
        <h2 className={headingStyle}>{t('netting.page_title')}</h2>
        <NettingUpdaterForm />
      </div>
    </div>
  )
}

export default NettingUpdaterPage
